import { useCallback } from 'react';

const SUBMIT_URL = process.env.REACT_APP_HUBSPOT_SUBMIT_URL;

const getHutk = () => {
  try {
    return document.cookie
      .split('; ')
      .find(r => r.startsWith('hubspotutk='))
      ?.split('=')[1] ?? null;
  } catch { return null; }
};

const submit = (fields, pageUri) => {
  // Fire-and-forget — never await this, never block the UI
  const body = {
    fields,
    context: {
      pageUri: pageUri || window.location.href,
      pageName: document.title,
    },
  };
  const hutk = getHutk();
  if (hutk) body.context.hutk = hutk;

  // HubSpot tracking temporarily disabled
  // fetch(SUBMIT_URL, {
  //   method: 'POST',
  //   headers: { 'Content-Type': 'application/json' },
  //   body: JSON.stringify(body),
  // }).catch(() => { /* silent — never surface HubSpot errors to user */ });
};

const useHubSpot = () => {
  const trackStep = useCallback((data = {}) => {
    // data shape: { email, currentStep, furthestStep, lastStepAt,
    //   completed, pmsConnected, coverageTier, idVerificationType,
    //   numberOfProperties, completedAt }
    const fields = [];

    const add = (name, value) => {
      if (value !== null && value !== undefined && value !== '') {
        fields.push({ name, value: String(value) });
      }
    };

    add('email',                  data.email);
    add('current_onboarding_step', data.currentStep);
    add('furthest_step_reached', data.furthestStep);
    add('last_step_completed_at', data.lastStepAt
      || new Date().toISOString());
    add('onboarding_completed',   data.completed ? 'true' : undefined);
    add('pms_connected',          data.pmsConnected);
    add('current_pms',            data.currentPms);
    add('current_protection_methods', data.currentProtections);
    add('looking_for_today',          data.lookingFor);
    add('how_did_you_hear_about_happy_guest', data.heardAboutUs);
    add('coverage_tier_selected',          data.coverageTier);
    add('id_verification_type',   data.idVerificationType);
    add('number_of_properties',   data.numberOfProperties);
    add('onboarding_completed_at', data.completedAt);

    if (fields.length === 0) return;
    submit(fields, data.pageUri);
  }, []);

  const identify = useCallback((email) => {
    if (!email) return;
    try {
      // HubSpot tracking temporarily disabled
      // window._hsq = window._hsq || [];
      // window._hsq.push(['identify', { email }]);
    } catch { /* silent */ }
  }, []);

  return { trackStep, identify };
};

export default useHubSpot;
